import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _bindInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/bind';
import _findIndexInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find-index';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import _Object$getOwnPropertySymbols from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _Object$getOwnPropertyDescriptor from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor';
import _forEachInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/for-each';
import _Object$getOwnPropertyDescriptors from '@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors';
import _Object$defineProperties from '@babel/runtime-corejs3/core-js-stable/object/define-properties';
import _Object$defineProperty from '@babel/runtime-corejs3/core-js-stable/object/define-property';
import { ResizeObserver } from '@juggle/resize-observer';
import classNames from 'classnames/bind';
import React, { useRef, useState, forwardRef } from 'react';
import { useIsomorphicLayoutEffect } from 'react-use';
import e from '../../../../../node_modules/scroll-into-view-if-needed/dist/index.js';
import AnchorButton from '../common/AnchorButton.js';
import COLOR from '../../foundation/color.js';
import styles from './LineTab.module.scss.js';

var _excluded = ["icon", "tabName", "active"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var cx = _bindInstanceProperty(classNames).call(classNames, styles);
var LineTabItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var icon = _ref.icon,
    tabName = _ref.tabName,
    active = _ref.active,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("li", {
    className: cx('item'),
    ref: ref
  }, /*#__PURE__*/React.createElement(AnchorButton, _objectSpread({
    className: cx('link', {
      'is-selected': active
    })
  }, rest), icon && /*#__PURE__*/React.createElement("span", {
    className: cx('icon')
  }, icon), tabName && /*#__PURE__*/React.createElement("span", null, tabName), active && /*#__PURE__*/React.createElement("span", {
    className: "blind"
  }, "\uD604\uC7AC \uC704\uCE58")));
});
function LineTab(_ref2) {
  var _ref2$bgColor = _ref2.bgColor,
    bgColor = _ref2$bgColor === void 0 ? COLOR.white.name : _ref2$bgColor,
    typeLayout = _ref2.typeLayout,
    type = _ref2.type,
    _ref2$maxWidthType = _ref2.maxWidthType,
    maxWidthType = _ref2$maxWidthType === void 0 ? 'full' : _ref2$maxWidthType,
    items = _ref2.items,
    selectedKey = _ref2.selectedKey,
    selectedIndex = _ref2.selectedIndex;
  var $tab = useRef(null);
  var $items = useRef([]);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    scrollable = _useState2[0],
    setScrollable = _useState2[1];
  var adjustScrollable = function adjustScrollable() {
    var _$tab$current$clientW, _$tab$current, _$tab$current$scrollW, _$tab$current2;
    var tabClientWidth = (_$tab$current$clientW = (_$tab$current = $tab.current) === null || _$tab$current === void 0 ? void 0 : _$tab$current.clientWidth) !== null && _$tab$current$clientW !== void 0 ? _$tab$current$clientW : 0;
    var tabScrollWidth = (_$tab$current$scrollW = (_$tab$current2 = $tab.current) === null || _$tab$current2 === void 0 ? void 0 : _$tab$current2.scrollWidth) !== null && _$tab$current$scrollW !== void 0 ? _$tab$current$scrollW : 0;
    var isTabOverflowed = tabClientWidth < tabScrollWidth;
    setScrollable(isTabOverflowed);
  };
  useIsomorphicLayoutEffect(function () {
    if (typeLayout !== 'flexible') {
      return;
    }
    var ResizeObserver$1 = window.ResizeObserver || ResizeObserver;
    var tabElement = $tab.current;
    var resizeObserver = new ResizeObserver$1(adjustScrollable);
    tabElement && resizeObserver.observe(tabElement);
    return function () {
      tabElement && resizeObserver.unobserve(tabElement);
    };
  }, [typeLayout]);
  useIsomorphicLayoutEffect(function () {
    if (!scrollable) {
      return;
    }
    var targetIdx = selectedIndex !== null && selectedIndex !== void 0 ? selectedIndex : _findIndexInstanceProperty(items).call(items, function (item) {
      return selectedKey === item.key;
    });
    if (targetIdx !== -1) {
      var $selectedTab = $items.current[targetIdx];
      $selectedTab && e($selectedTab, {
        inline: 'center',
        boundary: $tab.current
      });
    }
    // 선택된 키 또는 인덱스 값이 변경될 때만 스크롤 동작
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedKey, selectedIndex, scrollable]);
  return /*#__PURE__*/React.createElement("div", {
    className: cx('article', "bg-".concat(bgColor), {
      'x-scroll': scrollable
    })
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx('list', type, typeLayout, maxWidthType !== 'full' ? _defineProperty({}, "max-width-".concat(maxWidthType), maxWidthType) : undefined),
    ref: $tab
  }, _mapInstanceProperty(items).call(items, function (item, index) {
    var _item$key;
    var key = (_item$key = item.key) !== null && _item$key !== void 0 ? _item$key : index;
    return /*#__PURE__*/React.createElement(LineTabItem, _objectSpread(_objectSpread({}, item), {}, {
      key: key,
      active: selectedIndex === index || selectedKey === key,
      ref: function ref(node) {
        return $items.current[index] = node;
      }
    }));
  })));
}

export { LineTab as default };
